// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  button: { width: "100%" }
}), { index: 1 })